/**
 * Warte, auf Rückgabe einer Checkfunktion und führe dann einen Callback durch
 * @param check - Checkfunktion
 * @param execfunc - Callback
 * @param timeoutMs - Timeout
 */
export function waitUntil(check, execfunc, timeoutMs) {
    const timeWas = new Date();
    const wait = setInterval(function() {
        if (check() ) {
            execfunc()
            clearInterval(wait);
        } else if (new Date() - timeWas > timeoutMs) { // Timeout
            clearInterval(wait);
        }
    }, 100);
}

/**
 * Filter ausblenden
 * @param filter - Bezeichner des Filters
 */
export function hideFilter(filter) {
            const accordionBody = document.getElementById("glasses-filter-" + filter)
            if (!accordionBody) return;
            accordionBody.closest('.accordion-item').classList.add('hide-on-init')
}

/**
 * Filter ausblenden
 * @param filter - Bezeichner des Filters
 */
export function buildColorImageName(color, preferredView) {
    if(!preferredView ||
        (preferredView.toUpperCase() === 'MOOD' && !color.hasMood) ||
        (preferredView.toUpperCase() === 'FRNT' && !color.hasFront)
    ) {
        return color.image
    }
    let nameStart = "";
    let nameEnd = "";
    [nameStart, nameEnd] = color.image.split("-",-1)
    return nameStart + '_' + preferredView.toUpperCase() + '-' + nameEnd;

}


/**
 * Via data-cfg-hide-filters konfigurierte Filter ausblenden
 * @param config
 */
export function hideFilters(config) {
    let filtersToHide = []
    if(config.hideFilters === undefined) return;
    try {
        filtersToHide = JSON.parse(config.hideFilters);
    } catch (e) {
        return console.error("Die konfigurierte Option 'hideFilters' kann nicht als Json interpretiert werden.");
    }
    if (Array.isArray(filtersToHide)) {
        filtersToHide.forEach((filter) => {
            hideFilter(filter)
        })
    } else {
        console.log("Die konfigurierte Option 'hideFilters' kann nicht als Array interpretiert werden.");
    }
}